module.exports = "<svg id=\"9a0b266c-c5a3-4088-a65d-d84aa6dab296\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 49.64\"><title>arrow</title><path d=\"M0,0,43,24.84,0,49.64Z\" style=\"fill-rule: evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/triangle.svg
// module id = 579
// module chunks = 1